import _ from 'lodash';

import { EventMapping, ILogEventOptions } from '@scale/shared/types/events';
import { putRecords } from './aws/firehose';
import { STACK, NODE_ENV, SERVICE_NAME } from '@scale/frontend-lib/constants';

export { Event } from '@scale/shared/types/events';

let contextProperties: Record<string, any> = {};

/** Set the context properties to be logged with every event. */
export function setContext(context: Record<string, any>): void {
  contextProperties = context;
}

/** Clear the context properties being logged with every event. */
export function clearContext(): void {
  contextProperties = {};
}

/** get's value from ContextProperties */
export function getContextValue(key: string) {
  return contextProperties[key];
}

/** returns the existing Keys in the context */
export function getContextKeys(): string[] {
  return Object.keys(contextProperties);
}

export async function logEvent<E extends keyof EventMapping, T extends EventMapping[E]>(
  eventType: E,
  event: T,
  options: ILogEventOptions = {},
) {
  return await logEvents(eventType, [event], options);
}

export async function logEvents<E extends keyof EventMapping, T extends EventMapping[E]>(
  eventType: E,
  events: T[],
  options: ILogEventOptions = {},
) {
  const clientTime = new Date().toISOString();
  const baseContext = {
    env: {
      stack: STACK,
      environment: NODE_ENV,
      service: SERVICE_NAME,
    },
  };
  const context = options.omitContext ? baseContext : _.assign({}, baseContext, contextProperties);

  return await putRecords(
    `sf-event-${_.kebabCase(eventType)}`,
    events.map(p =>
      JSON.stringify({
        ...p,
        context,
        eventType,
        clientTime,
      }),
    ),
  );
}
